// import Modal from 'components/Modal';
import { Modal } from '@mui/material';
import i18n from 'config/i18n';
import { getDate } from 'helper/date';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import { Calendar, CalendarProvider } from 'zaman';
import TextField from '../TextField';
import * as S from './DatePicker.styles';
import { DatePickerProps } from './datePicker.interface';
// import './styles.css';
const DatePicker = ({
  id,
  control,
  label,
  disabled,
  onChange,
  defaultValue = null,
  minDate = null,
  maxDate = null,
  locale,
  error,
  required = false,
  dir,
}: DatePickerProps) => {
  const isLTR = i18n.dir() === 'ltr';
  const [selectedDateToShow, setSelectedDateToShow] = useState<string>();
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [minDateLocale, setMinDateLocale] = useState<Date>();
  const [maxDateLocale, setMaxDateLocale] = useState<Date>();
  // const initialLocale = locale || (isLTR ? 'en' : 'fa');
  const [showDatepicker, setShowDatepicker] = useState<boolean>(false);
  const [localeState, setLocaleState] = useState<any>(locale || isLTR ? 'en' : 'fa');
  const { t } = useTranslation();
  useEffect(() => {
    if (minDate) {
      setMinDateLocale(new Date(getDate(minDate, 'YYYY-MM-DD')));
    }
    if (maxDate) {
      setMaxDateLocale(new Date(getDate(maxDate, 'YYYY-MM-DD')));
    }

    const date = new Date(getDate(defaultValue || minDate || maxDate || new Date().getTime(), 'YYYY-MM-DD'));
    setSelectedDate(date);

    if (defaultValue) setSelectedDateToShow(getDate(defaultValue, undefined));
  }, [defaultValue, minDate, maxDate, isLTR]);

  const onChangeDate = (newValue: Date) => {
    setSelectedDateToShow(getDate(newValue));
    setSelectedDate(newValue);
    onChange(getDate(newValue, 'YYYY-MM-DD'));
    setShowDatepicker(false);
  };
  const changeLocale = () => {
    setLocaleState(localeState === 'fa' ? 'en' : 'fa');
    setShowDatepicker(false);
    setTimeout(() => {
      setShowDatepicker(true);
    }, 100);
  };

  return (
    <>
      <TextField
        dir={dir}
        id={id}
        control={control}
        label={label}
        placeholder="DD-MM-YYYY"
        disabled={disabled}
        readonly={true}
        error={error}
        fullWidth={true}
        defaultValue={selectedDateToShow || ''}
        onClick={() => !disabled && setShowDatepicker(true)}
        required={required}
      />
      <Modal open={showDatepicker}>
        <S.ModalWrapper
          onClick={() => {
            setShowDatepicker(false);
          }}
        >
          <div
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
          >
            <S.datepickerWrapper $isRtl={localeState === 'fa'}>
              <CalendarProvider locale={localeState} round="x2" direction={localeState === 'fa' ? 'rtl' : 'ltr'}>
                <Calendar
                  defaultValue={selectedDate}
                  onChange={(d) => {
                    onChangeDate(d);
                  }}
                />
                <p onClick={() => changeLocale()}>
                  {localeState === 'fa'
                    ? t('common.datepicker.changeLocale.toGaregorian')
                    : t('common.datepicker.changeLocale.toJalali')}
                </p>
              </CalendarProvider>
            </S.datepickerWrapper>
          </div>
        </S.ModalWrapper>
      </Modal>
    </>
  );
};

export default DatePicker;
